import { IStage, authproviderwrapper } from '@metservicedev/platforms-services-interface';
import { AGENT_ORGANISATION_IDS, userInfoUrls } from './config';
import { ORGANISATION_TYPE, ORGANISATION_TYPE_IDS, USER_TYPE } from './constants';

//Eventually get and update days since login fields in the user table
export const getUser = async (stage: IStage) => {
    try {
        const response = await fetch(userInfoUrls[stage], {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Metjwt: window.localStorage.metjwt,
            },
        });

        return await response.json();
    } catch (error) {
        return undefined;
    }
};

export const getIsSuperAdmin = async (stage: IStage) => {
    if (!window.localStorage.metjwt) return false;
    const response = await authproviderwrapper.http.checkIsMSLAdmin({
        stage,
        metjwt: window.localStorage.metjwt,
        clientId: '',
    });

    return response.data.isMSLAdmin;
};

export const organisationUtils = (organisationId: string) => {
    const isMetservice = () => {
        return ORGANISATION_TYPE_IDS[ORGANISATION_TYPE.METSERVICE].includes(organisationId);
    };

    const isReseller = () => {
        return ORGANISATION_TYPE_IDS[ORGANISATION_TYPE.RESELLER].includes(organisationId);
    };

    const isOpenAccess = () => {
        return ORGANISATION_TYPE_IDS[ORGANISATION_TYPE.OPEN_ACCESS] === organisationId;
    };

    const isAgent = () => {
        return AGENT_ORGANISATION_IDS.includes(organisationId);
    };

    const getOrganisationType = () => {
        if (isMetservice()) {
            return ORGANISATION_TYPE.METSERVICE;
        }

        if (isReseller()) {
            return ORGANISATION_TYPE.RESELLER;
        }

        if (isOpenAccess()) {
            return ORGANISATION_TYPE.OPEN_ACCESS;
        }

        return ORGANISATION_TYPE.BASIC;
    };

    const getUserType = () => {
        if (isAgent()) {
            return USER_TYPE.ADMIN;
        }

        if (isReseller()) {
            return USER_TYPE.RESELLER;
        }

        return USER_TYPE.BASIC;
    };

    return {
        isMetservice,
        isReseller,
        isOpenAccess,
        isAgent,
        getOrganisationType,
        getUserType,
    };
};
